import { config } from "./config";
// Regel 1 og reglene for app-merker i BRAND_RULES: merkene er leverte filer.
// `<app>-tile.svg` er varianten laget for nettopp en app-velger - navy flate,
// mint blekk, ett merke for begge fargeskjemaer. Den skal ikke omfarges,
// legges på en annen flate eller få en lys variant; trengs et nytt merke,
// hører det hjemme i kit-en. Vite bunter dem, så de serveres fra egen origin.
import reportsMerke from "@actiwise/brand/assets/apps/reports-tile.svg";
import companionMerke from "@actiwise/brand/assets/apps/companion-tile.svg";
import cabinetMerke from "@actiwise/brand/assets/apps/cabinet-tile.svg";
import contractsMerke from "@actiwise/brand/assets/apps/contracts-tile.svg";

export interface AppFlis {
  id: string;
  navn: string;
  beskrivelse: string;
  url: string;
  /** Realm-rollen som kreves. Må stemme med tabellen i actiwise-idp README §4. */
  paakrevdRolle: string;
  /** URL til app-merket fra brand-kit-en. Aldri en egen tegning eller emoji. */
  merke: string;
  /**
   * Frosset app: flisen vises ikke for noen, uansett roller. Oppføringen,
   * merket og URL-en blir stående, så å tine den er å fjerne denne linja.
   * Skriv dato og grunn i en kommentar ved siden av.
   */
  frosset?: true;
}

/**
 * Katalogen over apper i porteføljen. Rollenavnene her MÅ stemme med
 * realm-rollene i `keycloak/actiwise-realm.json`; gjør de ikke det, forsvinner
 * flisen stille for alle. `scripts/check-apps.mjs` sjekker at de finnes.
 */
export const apper: AppFlis[] = [
  {
    id: "reports",
    navn: "ActiWise Reports",
    beskrivelse: "Salgsaktiviteter og rapportering",
    // Ikke approta. Den laster Reports' SPA, som ikke vet noe om SSO-sesjonen
    // her og derfor viser sitt eget innloggingsskjema -- brukeren har nettopp
    // logget inn, og blir bedt om det igjen. `/auth/oidc/login` starter i
    // stedet Reports' egen OIDC-runde: Keycloak kjenner igjen sesjonen og
    // sender brukeren rett tilbake, så rundturen er usynlig.
    url: `${config.apper.reports}/auth/oidc/login`,
    paakrevdRolle: "reports-user",
    merke: reportsMerke,
  },
  {
    id: "companion",
    navn: "ActiWise Companion",
    beskrivelse: "Assistent for feltarbeid",
    url: config.apper.companion,
    paakrevdRolle: "companion-user",
    merke: companionMerke,
  },
  {
    id: "cabinet",
    navn: "Cabinet",
    beskrivelse: "Prosjekt- og anbudsstyring",
    url: config.apper.cabinet,
    paakrevdRolle: "cabinet-user",
    merke: cabinetMerke,
  },
  {
    id: "contracts",
    navn: "ActiWise Contracts",
    beskrivelse: "Kontrakter, frister og signering",
    url: config.apper.contracts,
    paakrevdRolle: "contracts-user",
    merke: contractsMerke,
  },
];

export function tilgjengeligeApper(roller: Set<string>): AppFlis[] {
  return apper.filter((app) => !app.frosset && roller.has(app.paakrevdRolle));
}
